module.exports = __webpack_public_path__ + "img/chat-gpt-integration-cover.9e22f69b.jpeg";